// extracted by mini-css-extract-plugin
export default {"title":"PopularTopics_title__x1n5D","row":"PopularTopics_row__czjiB","item":"PopularTopics_item__JyEFC","itemOn":"PopularTopics_itemOn__56D5m"};